import React, { useState } from "react";
import PropTypes from "prop-types";
import UrgencySignalWrapper from "../urgency-signal/wrapper";
import Pill from "./pill";
import { SizeScale } from "rtr-constants";

const SizePills = ({ onSelect, skus, availability, availabilityLoaded, availabilityError, hideOneSize }) => {
  const [selectedSize, setSelectedSize] = useState(null);

  const handleSelect = size => {
    setSelectedSize(size);
    if (onSelect) onSelect(size);
  };
  // Check if the product has only one SKU and that SKU is labeled "One Size"
  const isOneSizeOnly = skus?.length === 1 && skus[0]?.sizeDisplayText === SizeScale.ONE_SIZE;
  // Hide "One Size" display only for accessories
  const shouldHideOneSize = hideOneSize && isOneSizeOnly;

  // Autoselect if oneSize product
  if (isOneSizeOnly && !selectedSize) {
    handleSelect(skus[0]);
  }

  return (
    <>
      <div className="mt-8 mb-3 flex justify-between">
        {!shouldHideOneSize && (
          <div>
            <span className="font-medium">Size: </span> &nbsp;
            <span>{selectedSize?.sizeDisplayText ? `Size ${selectedSize?.sizeDisplayText}` : ""}</span>
          </div>
        )}
        <UrgencySignalWrapper selectedSku={selectedSize?.sku} availability={availability} />
      </div>
      <p>{availabilityError}</p>
      <div className="flex flex-wrap gap-3">
        {skus
          ?.filter(size => !(shouldHideOneSize && size.sizeDisplayText === "One Size"))
          .map(size => (
            <Pill
              key={size?.sku}
              availabilityLoaded={!!availabilityLoaded}
              availability={availability}
              sizeToRender={size}
              selectedSize={selectedSize}
              handleSelect={handleSelect}
            />
          ))}
      </div>
    </>
  );
};

SizePills.propTypes = {
  onSelect: PropTypes.func,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      sizeDisplayText: PropTypes.string,
    })
  ).isRequired,
  availability: PropTypes.arrayOf(
    PropTypes.shape({
      sku: PropTypes.string,
      availableCount: PropTypes.number,
    })
  ).isRequired,
  availabilityLoaded: PropTypes.bool,
  availabilityError: PropTypes.string,
  hideOneSize: PropTypes.bool,
};

export default SizePills;
